<script setup>
const emit = defineEmits([
  "update:modelValue",
  "close-only",
  "close-and-notify",
]);

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  /** Kept for backwards compatibility with existing usages; no longer used in the modal. */
  isEmptyTicket: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <BModal
    class="close-ticket-modal"
    hide-footer
    title="Close Ticket?"
    no-close-on-backdrop
    no-close-on-esc
    :model-value="modelValue"
    @close="$emit('update:modelValue', false)"
  >
    <span class="text-neutral-350 font-size-sm">
      Please confirm that this ticket should be closed
    </span>
    <div class="my-mt-4 d-flex column-gap-2 justify-content-end">
      <custom-button
        has-font-semi-bold
        button-type="white"
        @click="$emit('close-only')"
      >
        Close Ticket
      </custom-button>
      <custom-button
        has-font-semi-bold
        button-type="blue-transparent"
        @click="$emit('close-and-notify')"
      >
        Send Notification And Close Ticket
      </custom-button>
    </div>
  </BModal>
</template>

<style lang="scss">
.close-ticket-modal {
  .modal-dialog {
    width: 460px;
  }

  .modal-header {
    padding: 1.5rem 2rem 0.75rem 2rem;
  }

  .modal-body {
    padding: 0.75em 2rem 1.5rem 2rem;
  }
}
</style>
